const state = {
  LoginShowOrNot: true, // 是否登录的判断
  urlData: '123',
  GoodLengthData: 0, // 顶部购物车的总数
  orgGid:'',
  name: '',
  adminState: '',
  orgName: ''
}

const mutations = {
  setLoginShowOrNot(state, newValue) {
    state.LoginShowOrNot = newValue;
  },
  setGoodLengthData(state, value) {
    state.GoodLengthData = value;
  },
  setUserInfo(state, payload) {
    state.name = payload.name
    state.adminState = payload.adminState
    state.orgName = payload.orgName
    state.orgGid = payload.orgGid
  },
  clearUserInfo(state) {
    state.name = ''
    state.adminState = ''
    state.orgName = ''
    state.orgGid = ''
    state.LoginShowOrNot = true
    state.GoodLengthData = 0
  }
}

const actions = {
  // 需要就写
}

export default {
  namespaced: true, // 推荐，防止命名冲突
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/DataStorage.js